export default __webpack_public_path__ + "static/commmune-customer-success2-3c15bfd255351924bf45540ad63d4502.png";